module.exports = __webpack_public_path__ + "img/wb.6f37c2b7.jpg";